import config from 'cio/config/environment';
import { API_TRIGGERED_BROADCAST_SETUP_STEPS, DEFAULT_CAMPAIGN_SETUP_STEPS } from 'cio/utils/campaign-navigation';
import { DEFAULT_NEWSLETTER_SETUP_STEPS } from 'cio/utils/newsletter-navigation';

export function duration() {
  return config.isTest ? 0 : 250;
}

// The transition animation doesn't work correctly for the setup.workflow.actions
// sub route - we need to keep it to the setup.workflow route
function removeActionsSubRoute(path) {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (path.includes('workflow.actions')) {
    return path.replace('.actions', '');
  }

  return path;
}

export default function () {
  this.setDefault({ duration: duration() });

  let wizardTransition = (fromRoute) => {
    this.transition(
      this.fromRoute(fromRoute),
      this.use('notifyService', 'toLeftWithCleanup'),
      this.reverse('notifyService', 'toRightWithCleanup'),
    );
  };

  DEFAULT_CAMPAIGN_SETUP_STEPS.forEach((step) => {
    let path = removeActionsSubRoute(step.path);
    wizardTransition(path);
  });

  API_TRIGGERED_BROADCAST_SETUP_STEPS.forEach((step) => {
    let path = removeActionsSubRoute(step.path);
    wizardTransition(path);
  });

  DEFAULT_NEWSLETTER_SETUP_STEPS.forEach((step) => {
    wizardTransition(step.path);
  });

  // Notify workflow loading route transitions, too (but use default "transition" to
  // not do any extra animations)
  this.transition(
    this.fromRoute('campaigns.campaign.setup.workflow.loading'),
    this.toRoute('campaigns.campaign.setup.workflow.actions'),
    this.use('notifyService', 'default'),
  );
  this.transition(
    this.fromRoute('broadcasts.broadcast.setup.workflow.loading'),
    this.toRoute('broadcasts.broadcast.setup.workflow.actions'),
    this.use('notifyService', 'default'),
  );

  ['index', 'preprocessing', 'validation', 'fields', 'validating', 'review', 'importing'].forEach(function (route) {
    wizardTransition(`imports.import.setup.${route}`);
  });

  ['index', 'settings', 'review'].forEach(function (route) {
    wizardTransition(`transactional.message.setup.${route}`);
  });

  ['index', 'preprocessing', 'map', 'validating', 'review'].forEach(function (route) {
    wizardTransition(`segments.segment.imports.csv.setup.${route}`);
  });

  // TODO: Figure out how to refactor
  this.transition(
    this.fromValue((page) => page.slug === 'integrate'),
    this.use('toLeft'),
    this.reverse('toRight'),
  );

  this.transition(
    this.toValue((page) => page.slug === 'configure'),
    this.use('toLeft'),
    this.reverse('toRight'),
  );

  this.transition(
    this.fromValue('integrate'),
    this.toValue((page) => page.slug === 'engage'),
    this.use('toLeft'),
    this.reverse('toRight'),
  );

  this.transition(
    this.fromValue('engage'),
    this.toValue((page) => page.slug === 'configure'),
    this.use('toLeft'),
    this.reverse('toRight'),
  );
}
